function GoogleTagManager() {
  const metaNew = document.createElement("script");
  metaNew.textContent = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-W2P77FP');
`;
  document.head.appendChild(metaNew);
}

if (process.env.NODE_ENV === "production") {
  if ('requestIdleCallback' in window) {
    requestIdleCallback(() => {
      GoogleTagManager();
      window.GoogleTagManager = GoogleTagManager;
    });
  } else {
    window.addEventListener('load', () => {
      GoogleTagManager();
      window.GoogleTagManager = GoogleTagManager;
    });
  }
}


// Function to handle advisory-board URL correction
function handleAdvisoryBoardRedirect() {
  const currentPath = window.location.pathname;

  // Check if the current path is "/advisory-board/sam-khashman"
  if (currentPath === "/advisory-board/sam-khashman") {
    // Do nothing for this specific URL
    return;
  }

  // Check if the path contains "/advisory-board/" and is not the exact match above
  if (currentPath.includes("/advisory-board/")) {
    // Remove "/advisory-board" from the path
    const correctedPath = currentPath.replace("/advisory-board", "");
    const newUrl = `${window.location.origin}${correctedPath}${window.location.search}`;

    // Redirect to the corrected URL
    window.location.href = newUrl;
  }
}

// Execute the advisory-board redirect logic on page load
document.addEventListener("DOMContentLoaded", handleAdvisoryBoardRedirect);